/*
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: zhiqiang.xia@dsicm.com
 * @Date: 2021-07-20 17:32:12
 * @LastEditors: zhiqiang.xia@dsicm.com
 * @LastEditTime: 2022-08-22 17:18:06
 * @FilePath: \新建文件夹 (2)\dsicm-admin-web\src\api\questionnaireManage.js
 */
//引入接口文档
import req from '@/utils/req.js'

//问卷系统-试卷添加,并获取ID
export function addQuestionnaire(params) {
    return req.post("/admin/qs-exam-paper/insertReturnId", params);
}
//问卷系统-试卷分页查询
export function pageQuestionnaire(params) {
    return req.post("/admin/qs-exam-paper/page", params);
}
//疗管问卷选择
export function getQuestionnaire(params) {
    return req.post("/admin/qs-exam-paper/pageQuery", params);
}
//问卷系统-试卷更新
export function updateQuestionnaire(params) {
    return req.put("/admin/qs-exam-paper/update", params);
}
//问卷系统-停用-启用
export function changeStatus(params) {
    return req.put(`/admin/qs-exam-paper/updateStatus?id=${params.id}`);
}
//问卷系统-试卷详情
export function questionnaireDetails(params) {
    return req.get(`/admin/qs-exam-paper/${params.id}`);
}
//问卷系统-试卷删除
export function deleteQuestionnaire(params) {
    return req.delete(`/admin/qs-exam-paper/${params.id}`);
}
//问卷系统-问卷类型列表查询
export function queryQuestionTypeList(params) {
    return req.post("/admin/qs-exam-type/list", params);
}
//获取疾病类型/主要诊断
export function api_disease_type(params) {
    return req.get("/admin/disease-type", params);
}

//问卷系统-问卷发布
export function publishExamPaper(params) {
    return req.put(`/admin/qs-exam-paper/publishExamPaper/${params}`);
}

//问卷系统-试卷分页查询
export function queryList(params) {
    return req.post("/admin/qs-exam-paper/page", params);
}

//问卷系统-问卷单个推送
export function pushExamPaperSingle(params) {
    return req.post("/admin/qs-answer-sheet/pushExamPaperSingle", params);
}
//问卷系统-L疗管--问卷多条推送
export function pushExamPaperBatch(params) {
    return req.post("/admin/qs-answer-sheet/push/batch", params);
} 
//判断当前房间类型
export function getCustomerService(params) {
    return req.get(`/admin/whole-course/getCustomerServiceByGroupCode?groupCode=${params}`);
}
//问卷模板-引用
export function quoteExamPaper(params) {
    return req.post(`/admin/qs-exam-paper/quoteExamPaper/${params}`);
}

//获取培训教程
// export function pageToRelatePush(params) {
//     return req.post("/admin/train-chapter/pageToRelatePush", params);
// }

//获取培训教程
export function pageToRelatePush(params) {
    return req.post("/admin/train-chapter/getRelatePushTrainCourseTree", params);
}

//关联推送保存
export function saveBatch(params) {
    return req.post("/admin/relate-push/saveBatch", params);
}

//关联推送选择培训教程模糊搜索下拉框
export function selectRelatePushCourseList(params) {
    return req.post("/admin/train-course/selectRelatePushCourseList", params);
}


//删除培训教程章节
export function deleteChapter(params) {
    return req.post("/admin/train-chapter/deleteChapter?id=" + params.id,);
}

//根据问卷Id查询推荐服务配置详情
export function detailByExamPaperId(params) {
  return req.get(`/admin/qs-exam-paper-recommend-service/detailByExamPaperId/${params}`);
}

